import { FacetsGroupConfig, FacetsGroups, FacetState } from '../../../models';
import { Dictionary } from '../../../utils';
import { GetFacetConfigByName } from '../../config/getters/facet.getter';
import { GETTERS_KEYS } from '../../store.const';
import { AddFacetsToGroupPayload } from '../mutations/set-facets-groups.mutation';
import { SEARCH_ACTIONS_KEYS, SEARCH_GETTERS_KEYS, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class SetFacetsGroupsAction implements SearchAction {

  actions = {
    [SEARCH_ACTIONS_KEYS.setFacetsGroupsFromConfig]: ({ rootGetters, commit }: SearchContext): void => {
      const facetsGroupsConfig: Dictionary<FacetsGroupConfig> = rootGetters[GETTERS_KEYS.config.facetsGroups];
      commit(SEARCH_MUTATIONS_KEYS.setFacetsGroups, this.getFacetsGroups(facetsGroupsConfig));
    },
    [SEARCH_ACTIONS_KEYS.setRemainingFacets]: (context: SearchContext): void => {
      const { rootGetters, commit } = context;
      const facetsGroupsConfig: Dictionary<FacetsGroupConfig> = rootGetters[GETTERS_KEYS.config.facetsGroups];
      Object.entries(facetsGroupsConfig).forEach(([groupId, facetsGroupConfig]) => {
        if (facetsGroupConfig.addRemainingFacets) {
          const facets = this.getNewFacets(context, groupId);
          const payload: AddFacetsToGroupPayload = { groupId, facets };
          commit(SEARCH_MUTATIONS_KEYS.addFacetsToGroup, payload);
        }
      });
    }
  };

  protected getFacetsGroups(facetsGroupsConfig: Dictionary<FacetsGroupConfig>): FacetsGroups {
    return Object.entries(facetsGroupsConfig).reduce<FacetsGroups>((facetsGroups, [groupId, groupConfig]) => {
      facetsGroups[groupId] = {
        collapsed: groupConfig.startCollapsed,
        facets: this.getFacets(groupConfig)
      };
      return facetsGroups;
    }, {});
  }

  protected getFacets(groupConfig: FacetsGroupConfig): Dictionary<FacetState> {
    return Object.entries(groupConfig.facets).reduce<Dictionary<FacetState>>((facets, [facetName, facetConfig]) => {
      facets[facetName] = { collapsed: facetConfig.startCollapsed };
      return facets;
    }, {});
  }

  protected getNewFacets({ state, getters, rootGetters }: SearchContext, groupId: string) {
    const { excludeFromRemainingFacets }: FacetsGroupConfig = rootGetters[GETTERS_KEYS.config.facetsGroups][groupId];
    const groupFacets = state.facetsGroups[groupId]?.facets;
    const remainingFacets: string[] = getters[SEARCH_GETTERS_KEYS.remainingFacets];
    const getFacetConfig: GetFacetConfigByName = rootGetters[GETTERS_KEYS.config.facet];
    return remainingFacets.reduce((newFacetsState, facetName) => {
      if (!excludeFromRemainingFacets.includes(facetName) && !groupFacets?.[facetName]) {
        const { startCollapsed } = getFacetConfig(facetName, groupId);
        newFacetsState[facetName] = { collapsed: startCollapsed };
      }
      return newFacetsState;
    }, {} as Dictionary<FacetState>);
  }
}
